/**
 * Initialize scroll handler
 */
export function initializeScrollHandler() {

	const sections = document.querySelectorAll( '.page-slides > *:not(:first-child)' );
	let currentIndex = 0;
	let touchStartY = 0;
	let canIncrement = true;

	let total = 1;

	sections.forEach( ( section ) => {

		if ( section.nodeName === 'SECTION' || section.nodeName === 'FOOTER' ) {

			total++;

		}

	} );

	const contactButtonMenu = document.querySelector( '.page-template-page-slides .page-header .menu-item--contact-close' );
	const footer = document.querySelector( '.page-template-page-slides .page-slides .page-footer' );

	if ( contactButtonMenu ) {

		contactButtonMenu.addEventListener( 'click', function handleContactButtonClick( event ) {

			event.preventDefault();
			footer.style.transform = 'translateY(0px)';

		} );

	}

	/**
	 * Handle scroll event
	 * @param {Event} event - The event object
	 */
	function handleScroll( event ) {

		let deltaY = 0;

		if ( event.type === 'wheel' ) {

			deltaY = event.deltaY;

		} else if ( event.type === 'keydown' ) {

			if ( event.key === 'ArrowDown' ) {

				deltaY = 100;

			} else if ( event.key === 'ArrowUp' ) {

				deltaY = -100;

			}

		} else if ( event.type === 'touchmove' ) {

			deltaY = touchStartY - event.touches[ 0 ].clientY;

		}

		if ( Math.abs( deltaY ) >= 10 && canIncrement ) {

			if ( deltaY > 0 && currentIndex < total - 1 ) {

				sections[ currentIndex ].style.transform = 'translateY(0)';

				if ( window.innerWidth > 768 ) {

					for ( let i = 0; i < total; i++ ) {

						const section = sections[ i ];

						if ( i === currentIndex ) {

							const imageBlock = section.querySelector( '.b-hero .wp-block-image img' );
							if ( imageBlock ) {

								imageBlock.style.transform = 'scale(1)';

							}

						} else {

							const imageBlock = section.querySelector( '.b-hero .wp-block-image img' );
							if ( imageBlock ) {

								imageBlock.style.transform = 'scale(1.3)';

							}

						}

					}

				}

				currentIndex++;

			} else if ( deltaY < 0 && currentIndex > 0 ) {

				currentIndex--;
				sections[ currentIndex ].style.transform = 'translateY(100%)';
				footer.style.transform = 'translateY(100%)';
				if ( window.innerWidth > 768 ) {

					for ( let i = 0; i < total; i++ ) {

						const section = sections[ i ];

						if ( i === currentIndex - 1 ) {

							const imageBlock = section.querySelector( '.b-hero .wp-block-image img' );
							if ( imageBlock ) {

								imageBlock.style.transform = 'scale(1)';

							}

						} else {

							const imageBlock = section.querySelector( '.b-hero .wp-block-image img' );
							if ( imageBlock ) {

								imageBlock.style.transform = 'scale(1.3)';

							}

						}

					}

				}

			} else if ( deltaY < 0 && currentIndex === 0 ) {

				footer.style.transform = 'translateY(100%)';

			}

			canIncrement = false;

			setTimeout( () => {

				canIncrement = true;

			}, event.type === 'wheel' ? 1000 : 500 );

		}

	}

	/**
	 * Handle touchstart event
	 * @param {TouchEvent} event - The touch event object
	 */
	function handleTouchStart( event ) {

		touchStartY = event.touches[ 0 ].clientY;

	}

	document.addEventListener( 'wheel', handleScroll );
	document.addEventListener( 'keydown', handleScroll );
	document.addEventListener( 'touchmove', handleScroll );
	document.addEventListener( 'touchstart', handleTouchStart );

}
